import React, { Fragment } from 'react'
import EnrolmentBookingSchedule from './enrolment-booking-schedule'

import CommonEnrolmentFields from './common-fields'
import Grid from '../../../../../ui/grid'
import { FormCheckbox } from '@myxplor/forms'
import AnyDayPicker from './any-day-picker'

const PeaFields = (props) => {
  const { values, onChange } = props
  return (
    <Fragment>
      Where a provider has identified a child is at risk of serious neglect or
      abuse, but no eligible individual can be identified.
      <CommonEnrolmentFields {...props}>
        {props.values.parent_id && (
          <EnrolmentBookingSchedule
            parent_id={props.values.parent_id}
            {...props}
          />
        )}
        <p> Reason For Provider Elegible Agreement * </p>
        <Grid>
          <FormCheckbox
            label='Service not able to identify a CCS eligible carer'
            name='enrolment_params.reasonForPEA_NOCARE'
            value={values.enrolment_params.reasonForPEA_NOCARE}
            onChange={
              values.enrolment_params.reasonForPEA_FOSKIN ? () => {} : onChange
            }
            loading={values.enrolment_params.reasonForPEA_FOSKIN}
            compact
          />

          <FormCheckbox
            label='Child is in formal foster/kinship care'
            name='enrolment_params.reasonForPEA_FOSKIN'
            value={values.enrolment_params.reasonForPEA_FOSKIN}
            onChange={
              values.enrolment_params.reasonForPEA_NOCARE ? () => {} : onChange
            }
            loading={values.enrolment_params.reasonForPEA_NOCARE}
            compact
          />
        </Grid>
        <Grid>
          <AnyDayPicker
            name='enrolment_params.start_date'
            label='Start Date'
            value={values.enrolment_params.start_date}
            required={true}
            onChange={onChange}
          />
          <AnyDayPicker
            name='enrolment_params.end_date'
            label='End Date'
            value={values.enrolment_params.end_date}
            required={true}
            onChange={onChange}
          />
        </Grid>
        
      </CommonEnrolmentFields>
    </Fragment>
  )
}

export default PeaFields



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/pea-fields.js